"use strict";
import { NavLink } from "react-router-dom";
import { Flex, Popover, Text, styled, useMedia } from "ui/src";
import { ArrowChangeDown } from "components/Icons/ArrowChangeDown";
import { NavDropdown } from "components/NavBar/NavDropdown";
import { useMoreMenu, usePrimaryNav } from "components/NavBar/CompanyMenu/Content";
const NavItemText = styled(Text, {
  variant: "buttonLabel2",
  color: "$neutral2",
  animation: "fast",
  hoverStyle: { color: "$neutral1" },
  variants: {
    active: {
      true: { color: "$neutral1" }
    }
  }
});
const NavItemBox = styled(Flex, {
  row: true,
  alignItems: "center",
  py: "$spacing8",
  px: "$spacing12",
  borderRadius: "$rounded12",
  cursor: "pointer",
  animation: "fast",
  hoverStyle: { backgroundColor: "$surface2" },
  variants: {
    active: {
      true: { backgroundColor: "$surface2" }
    }
  }
});
const LinkReset = { textDecoration: "none" };
const MoreCard = styled(Flex, {
  width: 200,
  p: "$gap4",
  gap: "$spacing2",
  userSelect: "none",
  borderRadius: "$rounded12"
});
const MoreRow = styled(Flex, {
  row: true,
  alignItems: "center",
  gap: "$gap12",
  py: "$spacing12",
  px: "$spacing12",
  borderRadius: "$rounded12",
  animation: "fast",
  width: "100%",
  hoverStyle: { backgroundColor: "$surface2" },
  variants: {
    active: {
      true: { backgroundColor: "$surface2" }
    }
  }
});
function MoreRowLink({ child }) {
  const body = <MoreRow active={child.isActive}>
      <Flex flexShrink={0}>{child.icon}</Flex>
      <Text variant="body3" color={child.isActive ? "$neutral1" : "$neutral2"}>
        {child.title}
      </Text>
    </MoreRow>;
  if (child.href.startsWith("http")) {
    return <a
      href={child.href}
      target={child.target ? "_blank" : "_self"}
      rel={child.target ? "noopener noreferrer" : void 0}
      style={LinkReset}
    >
        {body}
      </a>;
  }
  return <NavLink to={child.href} style={LinkReset}>
      {body}
    </NavLink>;
}
function MoreMenu() {
  const more = useMoreMenu();
  if (!more.length) {
    return null;
  }
  return <Popover placement="bottom-start" hoverable stayInFrame allowFlip>
      <Popover.Trigger>
        <NavItemBox active={more.some((child) => child.isActive)}>
          <NavItemText active={more.some((child) => child.isActive)}>More</NavItemText>
          <Flex opacity={0.6} pl="$spacing4">
            <ArrowChangeDown width="10px" height="10px" />
          </Flex>
        </NavItemBox>
      </Popover.Trigger>
      <NavDropdown isOpen={false}>
        <MoreCard>
          {more.map((child) => <MoreRowLink key={child.href} child={child} />)}
        </MoreCard>
      </NavDropdown>
    </Popover>;
}
export function PrimaryNav() {
  const sections = usePrimaryNav();
  const media = useMedia();
  if (media.xl) {
    return null;
  }
  return <Flex row alignItems="center" gap="$gap4">
      {sections.map((section) => <NavLink key={section.title} to={section.href} style={LinkReset}>
          <NavItemBox active={section.isActive}>
            <NavItemText active={section.isActive}>{section.title}</NavItemText>
          </NavItemBox>
        </NavLink>)}
      <MoreMenu />
    </Flex>;
}
